import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination } from "swiper/modules";
import { faQuoteLeft, faQuoteRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Skills from "./Skills";
import { Image } from "react-bootstrap";
import { baseURL, CLIENTS, TESTIMONIAL } from "../../../Api/Api";
import axios from "axios";
import { Rating } from "@mui/material";
import { useTranslation } from "react-i18next";
import StatsSection from "./StatsSection";
import AboutSection from "./AboutSection";
import "./About.css";
import { Link } from "react-router-dom";

function About() {
  const skills = [
    { id: 1, title: "HTML", value: 100 },
    { id: 2, title: "CSS", value: 85 },
    { id: 3, title: "JavaScript", value: 75 },
    { id: 4, title: "React Js", value: 80 },
    { id: 5, title: "PHP", value: 70 },
    { id: 6, title: "Laravel", value: 85 },
  ];

  // Split the skills into two arrays, each with 4 skills
  const firstHalfSkills = skills.slice(0, 3);
  const secondHalfSkills = skills.slice(3);

  // Scroll-based animation
  const [isVisible, setIsVisible] = useState(false);
  const skillsRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.5 } // Trigger when 30% of the section is visible
    );

    if (skillsRef.current) {
      observer.observe(skillsRef.current);
    }

    return () => {
      if (skillsRef.current) {
        observer.unobserve(skillsRef.current);
      }
    };
  }, []);

  // Map the skills to components for each half
  const firstHalfComponents = firstHalfSkills.map((skill) => (
    <Skills key={skill.id} title={skill.title} value={skill.value} />
  ));
  const secondHalfComponents = secondHalfSkills.map((skill) => (
    <Skills key={skill.id} title={skill.title} value={skill.value} />
  ));

  const [clients, setClients] = useState([]);
  const [testi, setTesti] = useState([]);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    axios
      .get(`${baseURL}/${CLIENTS}/view`)
      .then((response) => setClients(response.data))
      .catch((error) => console.error("Error fetching clients:", error));
  }, []);

  useEffect(() => {
    axios
      .get(`${baseURL}/${TESTIMONIAL}/view`)
      .then((response) => setTesti(response.data))
      .catch((error) => console.error("Error fetching clients:", error));
  }, []);

  return (
    <>
      {/* Page Title */}
      <div className="page-title">
        <div className="heading">
          <div className="container">
            <div className="row d-flex justify-content-center text-center">
              <div className="col-lg-8">
                <h1 className="text-white" style={{ fontFamily: "Tajawal" }}>
                  {t("about")}
                </h1>
                <p className="mb-0 text-white">{t("aboutDesc")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Page Title */}

      {/* About Section */}
      <AboutSection />
      {/* /About Section */}

      {/* Stats Section */}
      <StatsSection />
      {/* /Stats Section */}

      {/* Skills Section */}
      <section id="skills" className="skills section" ref={skillsRef}>
        {/* Section Title */}
        <div className="container section-title">
          <h2>{t("skills")}</h2>
          <div>
            <span className="description-title">{t("mySkills")}</span>
          </div>
        </div>
        {/* End Section Title */}

        <div className="container">
          <div
            className={`row skills-content ${isVisible ? "fade-in" : "hidden"}`}
          >
            <div
              className="col-lg-6"
              style={{ direction: i18n.language === "ar" ? "ltr" : "ltr" }}
            >
              {firstHalfComponents}
            </div>
            <div
              className="col-lg-6"
              style={{ direction: i18n.language === "ar" ? "ltr" : "ltr" }}
            >
              {secondHalfComponents}
            </div>
          </div>
        </div>
      </section>
      {/* /Skills Section */}

      {/* Interests Section */}
      <section id="interests" className="interests section">
        {/* Section Title */}
        <div className="container section-title">
          <h2>{t("clients")}</h2>
          <div>
            <span className="description-title">{t("myClients")}</span>
          </div>
        </div>
        {/* End Section Title */}
        <div className="container">
          <div className="row gy-4">
            {clients.length > 0 ? (
              clients.map((client) => (
                <div key={client.id} className="col-lg-3 col-md-4">
                  <div className="features-item" style={{ height: "100px" }}>
                    <Image
                      src={client.image.path}
                      alt={client.title_en}
                      width={50}
                      height={50}
                    />
                    <h3 className="mx-3">
                      <Link className="stretched-link">
                        {i18n.language === "ar"
                          ? client.title_ar
                          : client.title_en}
                      </Link>
                    </h3>
                  </div>
                </div>
              ))
            ) : (
              <p>No clients found.</p>
            )}
          </div>
        </div>
      </section>
      {/* /Interests Section */}

      {/* Testimonials Section */}
      <section id="testimonials" className="testimonials section">
        {/* Section Title */}
        <div className="container section-title">
          <h2>{t("testimonials")}</h2>
          <div>
            <span className="description-title">{t("mco")}</span>
          </div>
        </div>
        {/* End Section Title */}
        <Swiper
          spaceBetween={30}
          centeredSlides={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          modules={[Autoplay, Pagination]}
          className="mySwiper container"
        >
          {testi.length > 0 ? (
            testi.map((testi) => (
              <SwiperSlide className="swiper-slide" key={testi.id}>
                <div className="testimonial-item">
                  <p>
                    <FontAwesomeIcon
                      icon={faQuoteLeft}
                      size="lg"
                      style={{ color: "#0e9069" }}
                    />
                    &nbsp;&nbsp;
                    <span>{testi.comment}</span>
                    &nbsp;&nbsp;
                    <FontAwesomeIcon
                      icon={faQuoteRight}
                      size="lg"
                      style={{ color: "#0e9069" }}
                    />
                  </p>
                  <h3 className="text-white ">{testi.name}</h3>
                  <Rating
                    value={testi.rating}
                    precision={0.5}
                    readOnly
                    className="ms-5"
                  />
                </div>
              </SwiperSlide>
            ))
          ) : (
            <p>No comments found.</p>
          )}
        </Swiper>
      </section>
      {/* /Testimonials Section */}
    </>
  );
}

export default About;
